import { TYPE } from '../actions/types'

export default function (state = {}, action) {
    switch (action.type) {
        case TYPE.SHOW_BOOKINGS:
            return { ...state, response: action.payload }
        default:
            return state;
    }
}

